import React, { useEffect, useState } from "react"

import useMousePosition from "../../hooks/mouse_poisition"
import isTouchDevice from "../../utils/is_touch_device"

const Cursor = () => {
    const { clientX, clientY } = useMousePosition()
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const handleMouseEnter = () => setIsVisible(true)
        const handleMouseLeave = () => setIsVisible(false)

        document.body.addEventListener("mouseenter", handleMouseEnter)
        document.body.addEventListener("mouseleave", handleMouseLeave)

        return () => {
            document.body.removeEventListener("mouseenter", handleMouseEnter)
            document.body.removeEventListener("mouseleave", handleMouseLeave)
        }
    }, [])

    if (isTouchDevice) return null

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                pointerEvents: "none",
                mixBlendMode: "hard-light",
            }}
        >
            <svg
                width={300}
                height={300}
                viewBox="0 0 600 600"
                style={{
                    position: "absolute",
                    left: clientX,
                    top: clientY,
                    transform: `translate(-50%, -50%)`,
                    fill: '#C9C7C6',
                    transition: "transform .2s ease-in-out",
                    opacity: isVisible && clientX > 1 ? 1 : 0,
                }}>
                <path
                    d="M207.72251892089844,458.63873291015625C199.8691177368164,429.5811411539714,193.97906748453775,216.62303161621094,231.28273010253906,203.40313720703125C268.58639272054035,190.18324279785156,423.6910934448242,350.26177469889325,431.54449462890625,379.3193664550781C439.3978958129883,408.376958211263,315.70679982503253,364.52879333496094,278.40313720703125,377.7486877441406C241.09947458902994,390.9685821533203,215.57592010498047,487.6963246663411,207.72251892089844,458.63873291015625C199.8691177368164,429.5811411539714,193.97906748453775,216.62303161621094,231.28273010253906,203.40313720703125"
                    fill="url(&quot;#SvgjsLinearGradient1000&quot;)"
                    transform="matrix(0.22537070214008412,0,2.1476735320713477e-17,0.22537070214008412,228.58253625268435,224.87461803551196)"
                    stroke-width="15"
                    stroke="#323949" stroke-opacity="1">
                </path>
                <defs>
                    <linearGradient id="SvgjsLinearGradient1000">
                        <stop stop-color="#C9C7C69a" offset="0">

                        </stop>
                        <stop stop-color="#C9C7C6a1" offset="1">

                        </stop>
                    </linearGradient>
                    <radialGradient id="SvgjsRadialGradient1001">
                        <stop stop-color="#C9C7C69a" offset="0">

                        </stop>
                        <stop stop-color="#C9C7C6a1" offset="1">

                        </stop>
                    </radialGradient>
                </defs>
            </svg>
        </div>
    )
}

export default Cursor